module.exports = __webpack_public_path__ + "img/espace-employeur.2f456763.jpg";